import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { ApplicationModule } from './application-modules.types';

export const APPLICATION_MODULES_API_URL = new InjectionToken<string>('Application modules api url');

@Injectable()
export class ApplicationModulesApiService {
  readonly #http = inject(HttpClient);
  readonly #url = inject(APPLICATION_MODULES_API_URL);

  get(personId: string): Observable<ApplicationModule[]> {
    const params = new HttpParams({ fromObject: { personId } });

    return this.#http.get<ApplicationModule[]>(this.#url, { params });
  }
}
